import { createApi } from '@reduxjs/toolkit/query/react';

import { apiClientPackageSchedules } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

export interface PreviewAppointment {
  id: number;
  date: string;
  start_time: string;
  end_time: string;
  service_type_id: number;
  service_type?: { id: number; name: string } | null;
  user_id: number;
  user?: { id: number; full_name: string } | null;
  repeat_weekday: string | null;
  repeat_start?: string | null;
  repeat_end?: string | null;
}

export interface LevelMovePreview {
  schedule: {
    id: number;
    start_date: string;
    end_date: string;
    locked_date?: string | null;
    package: { id: number; name: string };
  };
  repeats: PreviewAppointment[];
  fixed: PreviewAppointment[];
}

export interface LevelMovePayload {
  new_package_id: number;
  changeover_date: string;
  case_manager_id: number;
  repeat_appointment_ids: number[];
  fixed_appointment_ids: number[];
}

interface LevelMoveResult {
  new_schedule_id: number;
  moved_appointment_count: number;
}

export const packageSchedulesApi = createApi({
  reducerPath: 'packageSchedulesApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiClientPackageSchedules }),
  endpoints: (build) => ({
    getLevelMovePreview: build.query<LevelMovePreview, { scheduleId: number; changeoverDate: string }>({
      query: ({ scheduleId, changeoverDate }) => ({
        url: `/${scheduleId}/level-move-preview`,
        method: 'GET',
        params: { changeover_date: changeoverDate },
      }),
      transformResponse: (payload) => unwrap<LevelMovePreview>(payload),
    }),
    levelMove: build.mutation<LevelMoveResult, { scheduleId: number; payload: LevelMovePayload }>({
      query: ({ scheduleId, payload }) => ({
        url: `/${scheduleId}/level-move`,
        method: 'POST',
        body: payload,
      }),
      transformResponse: (payload) => unwrap<LevelMoveResult>(payload),
    }),
  }),
});

export const { useGetLevelMovePreviewQuery, useLevelMoveMutation } = packageSchedulesApi;
